import { SortDirection } from './SortDirection';
import { SortDefinition } from './SortDefinition';

export class PagedResultRequest {
  constructor(public pageNumber: number = 1, public sort: SortDefinition = null, public filter: any = null) {
  }

  static fromDatatable(datatable: any) {
    const sort = datatable.sorts[0];
    const pascalCaseField = sort.prop.charAt(0).toUpperCase() + sort.prop.slice(1);
    const sortDefinition = new SortDefinition(pascalCaseField, sort.dir === 'asc' ? SortDirection.Asc : SortDirection.Desc);
    return new PagedResultRequest(datatable.offset + 1, sortDefinition);
  }

  setSort(field: string) {
    const pascalCaseField = field.charAt(0).toUpperCase() + field.slice(1);
    
    if (!this.sort) {
      this.sort = new SortDefinition(pascalCaseField, SortDirection.Asc);
    } else if (this.sort.field !== pascalCaseField) {
      this.sort.field = pascalCaseField;
      this.sort.direction = SortDirection.Asc;
    } else if (this.sort.direction === SortDirection.Asc) {
      this.sort.direction = SortDirection.Desc;
    } else if (this.sort.direction === SortDirection.Desc) {
      this.sort.direction = SortDirection.Asc;
    }
    
    this.pageNumber = 1;
  }
  
  toQueryString() {
    return this.serialize(this);
  }

  private serialize(obj: any, prefix: string = null) {
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p) && obj[p] !== null) {
        const k = prefix ? prefix + '.' + p : p;
        const v = obj[p];
        if (obj instanceof Array) {
          str.push(encodeURIComponent(prefix) + '=' + encodeURIComponent(v));
        } else {
          str.push(typeof v === 'object' ?
            this.serialize(v, k) :
            encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
      }
    }
    return str.join('&');
  }
}
